import { render } from "./VideoGallery.vue?vue&type=template&id=2309ab96&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"

import "./VideoGallery.vue?vue&type=style&index=0&id=2309ab96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2309ab96"]])

export default __exports__